<!--
 * @Author: xuxiaofei
 * @Date: 2022-09-27 19:52:31
 * @LastEditTime: 2022-11-29 10:47:08
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @Description: 需求提报新建、编辑页面
 * @FilePath: \code\fe-mall\pages\index\src\routes\demand\index.vue
 -->
<template>
  <div>
    <SyForm
      v-if="detailData.remark && showRemark"
		  :model="extendFieldForm"
			style="font-size: 0"
			:span="span"
			:label-width="`${labelWidth}px`"
			:label-position="labelPosition"
			:pageType='pageType'
		>
      <SyFormItem
        :label="pageText.remark"
        :isText="true"
        :span="'0'"
      >
        <ReadText class="remark" :value="detailData.remark" computeHeight></ReadText>
      </SyFormItem>
    </SyForm>
    <div v-if="showNoData && showDataTip && !laoding" style="text-align: center">{{pageText.noData}}</div>
    <extend-field
      ref="extendField"
      v-bind="$attrs"
      :fieldList="detailData.fields"
      :layoutType="comLayoutType"
      :labelWidth="labelWidth"
      :labelPosition="labelPosition"
      :pageType="pageType"
    />
  </div>
</template>

<script>
import Api from './api.js'
import GetData from './../../../../utils/response'
import ExtendField from './../../products/extend-field/edit/index.vue'
import { ReadText } from './../../../../index.js'
import { componentMessage } from './../../utils'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
const detailData = {fields: []}
export default {
  name: 'DemandSubmissionEdit',
  components: {
    ExtendField,
    ReadText
  },
  props: {
    // 模板code
    templateCode: {
      type: [String, Number]
    },
    // 采购品类id
    purchaseCategoryId: {
      type: [String, Number]
    },
    // 来源 0、1、2、3
    sourceType: {
      type: [String, Number]
    },
    // 业务数据系统编码（编辑时传入）
    sysBizDataCode: {
      type: [String, Number]
    },
    // 是否展示数据相关的提示
    showDataTip: {
      type: Boolean,
      default: false
    },
    // 一行几列
    span: {
      type: [Number, String]
    },
    // 展示位置
		showLocation: {
			type: String, // product-edit 商品编辑页  demand-submission 需求提报
			default: 'product-edit'
		},
    // 是否展示说明
    showRemark: {
      type: Boolean,
      default: true
    },
    // 页面类型,弹窗形式值为'popup'
    pageType: {
      type: String
    },
		labelWidth: {
			type: Number,
			default: 120
		},
		labelPosition: {
			type: String
		}
	},
  data () {
    return {
      fixedDetaile: {},
      //提报详情
      detailData: JSON.parse(JSON.stringify(detailData)),
      pageText,
      laoding: false,
      // 编辑时用于提交的code
      temSysBizDataCode: null
    }
  },
  computed: {
    showNoData () {
      let status = true
      Array.isArray(this.detailData.fields) && this.detailData.fields.forEach(i => {
        !(this.project === 'supplier' && i?.supplierDisplay === 0) && (status = false)
      })
      return status
    },
    // 获取详情需要监听的字段
    repayDataChange () {
      return {
        sysBizDataCode: this.sysBizDataCode,
        purchaseCategoryId: this.purchaseCategoryId,
        templateCode: this.templateCode
      }
    },
    comLayoutType () {
			let layout = 'auto'
			// 只有在非商城品类提报页面才读取一行几列
			if (Number(this.detailData.layoutType) >= 0 && this.showLocation === 'demand-submission') {
        layout = this.detailData.layoutType
			}
      this.span && (layout = this.span)
			layout === 1 && (layout = '0')
			return layout
		}
  },
  watch: {
    repayDataChange: {
      handler: function (newVal) {
        if (newVal instanceof Object) {
          let keys = Object.keys(newVal)
          let find = keys.find(item => newVal[item] || newVal[item] === 0)
          if (!find) {
            this.detailData = JSON.parse(JSON.stringify(detailData))
            this.$emit('emitDemandDetaile', this.detailData)
          }
        }
      },
      immediate: true
    }
  },
  async created () {
    let verifyResult = componentMessage(['purchaser', 'mall'], '需求提报编辑组件 demand-submission')
		if (verifyResult) return
    // console.log(SyFormItem)
  },
  methods: {
    // 清空详情
    clearDetailData () {
      this.detailData = JSON.parse(JSON.stringify(detailData))
    },
    // 获取详情(需要引用该组件的页面手动触发)
    async getDetail ({fillAgain = false, relySysCode = false} = {}) {
      if (fillAgain) {
        this.temSysBizDataCode = null
      } else {
        this.temSysBizDataCode = this.sysBizDataCode
      }
      this.detailData = JSON.parse(JSON.stringify(detailData))
      let params = {}
      let api = {}
      this.laoding = true
      if (this.temSysBizDataCode) {
        // 编辑页的详情
        api = Api.getPurTempFieldEditDetails
        params = {
          sysBizDataCode: this.temSysBizDataCode
        }
      } else {
        api = Api.getPurTempFieldDetails
        params = {
          purchaserCategoryId: this.purchaseCategoryId,
          sysTempCode: this.templateCode
        }
      }
      // 依赖code但code没值，不去调用接口
      if (!(relySysCode && !this.temSysBizDataCode)) {
        let res = await GetData(this.$http(api.type, api.url, params))
        if (res.isOk && res.content) {
          this.detailData = JSON.parse(JSON.stringify(res.content))
        }
      }
      this.laoding = false
      this.$emit('emitDemandDetaile', this.detailData)
    },
    // 校验必填项
    async validateFieldInfo () {
      return this.$refs.extendField.validateFieldInfo()
    },
    async submit () {
      let validateResult = this.$refs.extendField.validateFieldInfo()
      return new Promise((resolve, reject) => {
        validateResult.then(async (extendForm) => {
          if (this.detailData.sysTempDetailsCode) {
            let saveBizData = Api.saveBizData
            let extendParams = {
              sourceType: this.sourceType,
              fields: extendForm,
              sysTempDetailsCode: this.detailData.sysTempDetailsCode,
              sysBizDataCode: this.temSysBizDataCode
            }
            // sysTempDetailsCode
            let result = await GetData(this.$http(saveBizData.type, saveBizData.url, extendParams))
            console.log(result)
            if (result.isOk && result.content) {
              resolve(result.content.sysBizDataCode)
            } else {
              resolve(null)
            }
          } else {
            resolve(null)
          }
          
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
